import { render, staticRenderFns } from "./TheHeaderActions.vue?vue&type=template&id=3c0946f0&"
import script from "./TheHeaderActions.vue?vue&type=script&lang=js&"
export * from "./TheHeaderActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports